import { DynamicNumberDescriptionAmountInput as DynamicNumberDescriptionAmountInputType } from '../../../../../types/Survey/Element'
import {
  DynamicNumberDescriptionAmountInputAnswer,
  DynamicNumberDescriptionAmountInput as DynamicNumberDescriptionAmountInputAnswerType,
} from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Input from '../../../../UI/Input/Input'
import Number from '../../../../UI/Input/Number'
import { PlusIcon } from '@heroicons/react/24/solid'
import { getDynamicNumberDescriptionAmountAnswer } from '../../../../hooks/useSurveyAnswer/transformElementsToAnswers'

const DynamicNumberDescriptionAmountInput: React.FC<
  Props<DynamicNumberDescriptionAmountInputType, DynamicNumberDescriptionAmountInputAnswerType>
> = ({ element, answerElement, updateElement }) => {
  const set = (uuid: string, prop: keyof DynamicNumberDescriptionAmountInputAnswer) => (value: string) => {
    // update answer
    const updatedAnswer = { ...answerElement }
    updatedAnswer.numberAnswers = answerElement.numberAnswers.map((tA) => (tA.uuid === uuid ? { ...tA, [prop]: value } : tA))

    updateElement(updatedAnswer)
  }

  const add = () => {
    // add new answer
    const updatedAnswer = { ...answerElement }
    updatedAnswer.numberAnswers.push(getDynamicNumberDescriptionAmountAnswer())

    updateElement(updatedAnswer)
  }

  return (
    <div>
      <Core element={element} answerElement={answerElement} />
      <div className="flex flex-col gap-3 mt-5">
        {answerElement.numberAnswers.map((tA, i) => (
          <div className="flex flex-row items-center gap-3" key={tA.uuid}>
            <div className="w-6 aspect-square shrink-0 bg-cyan rounded-full flex items-center justify-center text-white text-sm">{i + 1}</div>
            <Input
              key={tA.uuid + 'description'}
              value={tA.description}
              onChange={set(tA.uuid, 'description')}
              maxLength={100}
              className="xl:w-[40vw]"
              placeholder={element.descriptionPlaceholder}
            />
            <Number
              suffix={element.amountSuffix}
              key={tA.uuid + 'amount'}
              value={tA.amount}
              onChange={set(tA.uuid, 'amount')}
              className="xl:w-[40vw]"
            />
            <Number
              suffix={element.numberSuffix}
              key={tA.uuid + 'number'}
              value={tA.number}
              onChange={set(tA.uuid, 'number')}
              className="xl:w-[40vw]"
            />
          </div>
        ))}
        <div className="ml-auto w-6 aspect-square bg-cyan rounded-full flex items-center justify-center text-white cursor-pointer" onClick={add}>
          <PlusIcon className="fill-white w-5" />
        </div>
      </div>
    </div>
  )
}

export default DynamicNumberDescriptionAmountInput
